// Formats a number with a space as the thousands separator (e.g. 6490 -> "6 490", 44980 -> "44 980").
// Note: Intl.NumberFormat('hu-HU') does NOT group 4-digit numbers, so we group manually
// to keep prices consistent everywhere across the app.
export const formatPrice = (price) => {
  if (price === null || price === undefined || isNaN(price)) return '';
  return Math.round(Number(price))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
};
